import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useARC } from "providers/ARC/ARCProvider";
import { useRobotControl } from "providers/RobotControlProvider";

import FunctionalButton from "components/layout/FunctionalButton";

import { ReactComponent as ControlHideIcon } from "assets/svgs/ControlHide.svg";
import { ReactComponent as ControlShowIcon } from "assets/svgs/ControlShow.svg";

import { ConnectionState } from "lib/consts/ARC/connection";

const ShowControlButton = () => {
    const { t } = useTranslation("control");
    const { connectionState } = useARC();
    const { showControl, setShowControl } = useRobotControl();

    const isConnectedToARC = connectionState === ConnectionState.Connected;

    return (
        <FunctionalButton
            className={`control-button-type3 ${showControl && "control-button-active"} ${
                !isConnectedToARC && "control-button-disable"
            }`}
            icon={
                isConnectedToARC ? (
                    showControl ? (
                        <ControlShowIcon className="w-6" />
                    ) : (
                        <ControlHideIcon className="w-6" />
                    )
                ) : (
                    <ControlHideIcon className="w-6 text-black70" />
                )
            }
            hoverText={t("buttons.joystick")}
            disabled={!isConnectedToARC}
            onClick={() => setShowControl(!showControl)}
        />
    );
};

export default ShowControlButton;
